/* eslint-disable import/prefer-default-export */
export function formatCurrency(str: any) {
    return str?.toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
    });
}
